import { i18n } from '@/translations/i18n'

const rules = {
  'password': {
    params: ['target'],
    validate(value, { target }) {
      return value === target
    },
    message: i18n.t('my_account.reset_password.errors.not_equal'),
  },
}

export default extend => {
  Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule])
  })
}
